import CustomSelect from '@/components/ui/custom-select';
import { SERVICES_ITEMS } from '@/constants/ourservices';
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';

export default function MobileServicesSection({
  category_index,
}: {
  category_index: number;
}) {
  const [selected, setSelected] = useState('0');

  // Resetar activeService sempre que o category_index mudar
  useEffect(() => {
    setSelected('0');
  }, [category_index]);

  const services = SERVICES_ITEMS.categories[category_index]?.services ?? [];

  // Verificação defensiva: só renderizar se o activeService for válido
  if (parseInt(selected) >= services.length) {
    return null; // ou um loading/spinner, ou fallback amigável
  }

  return (
    <div className="lg:hidden flex flex-col rounded-xl border border-stone-400 w-full gap-6 p-6">
      <CustomSelect
        options={services.map((item, idx) => {
          return { label: item.title, value: idx.toString() };
        })}
        value={selected}
        onChange={setSelected}
        className="p-4 flex-1 font-bold bg-white border-gray-300 border"
      />

      <div className="text-base text-[#525252] text-center">
        {services[parseInt(selected)].description}
      </div>

      <div className="flex flex-col gap-4">
        {services[parseInt(selected)].cards.map((card, idx) => (
          <div
            key={idx}
            className="flex flex-col items-center border border-gray-300 rounded-md p-4 gap-2"
          >
            <Image
              src={card.icon_src}
              alt={card.title + ' icon'}
              height={44}
              width={44}
            />
            <h3 className="font-semibold text-lg text-bluecaixa">
              {card.title}
            </h3>
            <p className="text-base text-center text-gray-600">
              {card.description}
            </p>
          </div>
        ))}
      </div>

      <Link
        href={services[parseInt(selected)].href}
        className="w-full py-5 bg-orangecaixa text-white rounded-md text-sm font-semibold hover:text-stone-200 flex items-center justify-center gap-2"
      >
        <Image
          height={24}
          width={24}
          src="/icons/arrow-right-circle.png"
          alt="right arrow icon"
        />
        {services[parseInt(selected)].btnText}
      </Link>
    </div>
  );
}
